module.exports = __webpack_public_path__ + "img/IslandStateMusic.9ab8804f.svg";